import { computed, inject, Injectable } from '@angular/core';
import { EnvironmentOptionStore } from '@cardium/features/option/data-access';

@Injectable({ providedIn: 'root' })
export class EnvironmentOptionsService {
  private readonly store = inject(EnvironmentOptionStore);
  private readonly envOptionsMap = this.store.envOptionsMap;

  public readonly userForm = computed(() => {
    return this.envOptionsMap()['CARDIUM_USERFORM'];
  });
}
